import React from 'react';
import { dsButtonPrimary, joinButtonClasses } from '../../../utils/buttonStyles';

const NoUtilizationCard = ({ line, imgsrc, toggleHelp, classes = '', parent }) => {
  const getContent = () => {
    if (['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role')) && parent !== 'stepathon') {
      return (
        <div className='mt-8 border-t border-gray-200 pt-8 text-center'>
          <p className='mb-0 text-sm leading-relaxed text-gray-600'>
            To improve utilization, reach out to the marketing team for a customized plan and share it with HR.
          </p>
        </div>
      );
    }
    if (parent === 'stepathon') {
      return (
        <div className='mt-6 text-center'>
          <p className='mb-0 text-sm leading-relaxed text-gray-600 sm:text-base'>
            To increase engagement, create a stepathon for your organization.
          </p>
          <button
            type='button'
            onClick={(e) => toggleHelp(e.target)}
            className={joinButtonClasses(dsButtonPrimary, 'mt-5 h-10 w-full max-w-xs px-6 sm:w-auto')}
          >
            Create stepathon
          </button>
        </div>
      );
    }
    return (
      <div className='mt-6 text-center'>
        <p className='mb-0 text-sm leading-relaxed text-gray-600 sm:text-base'>
          To increase utilization, contact your{' '}
          <span className='font-semibold text-gray-800'>customer success manager</span>.
        </p>
        <button
          type='button'
          onClick={toggleHelp}
          className={joinButtonClasses(dsButtonPrimary, 'mt-5 h-10 w-full max-w-xs px-6 sm:w-auto')}
        >
          Talk to CSM
        </button>
      </div>
    );
  };

  const title = 'This feature has not been utilized';
  const subtitle =
    parent !== 'stepathon'
      ? `This section shows the ${line}`
      : 'This section shows the stepathon created by you';

  return (
    <div
      className={
        'mx-auto mt-6 w-full max-w-3xl rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm sm:px-10 md:py-12 ' +
        classes
      }
    >
      <div className='mx-auto flex max-w-xl flex-col items-center text-center'>
        <img
          src={imgsrc}
          className='mt-4 h-auto max-h-48 w-auto max-w-full object-contain'
          height={190}
          width={190}
          alt='Illustration for empty utilization'
        />
        <h2 className='mb-0 mt-4 text-ts-2xl font-fig-semibold leading-snug tracking-tight text-gray-900'>
          {title}
        </h2>
        <p className='mb-0 mt-3 text-sm leading-relaxed text-gray-600 sm:text-base'>{subtitle}</p>
      </div>
      {getContent()}
    </div>
  );
};

export default NoUtilizationCard;
